module.exports = __webpack_public_path__ + "static/media/ic_rec_stop.d368fd46.svg";